/* lua.js generated code 0.3.0 */

/* 
Copyright (c) 2011-2014 chukong-inc.com

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

 */
var Layer = cc.Layer
Layer.prototype.onTouch = function (callback, isMultiTouches, swallowTouches) {
    var self = this
    if (type(isMultiTouches) !== "boolean") {
        isMultiTouches = false
    }
    if (type(swallowTouches) !== "boolean") {
        swallowTouches = false
    }
    self.registerScriptTouchHandler(function (selTouch, event) {
        if (isMultiTouches) {
            cc.error('TODO: MultiTouchs')
            args = args[1]
            var points = table()
            var $limit7 = $len(args)
            for (var i = 1; i <= $limit7; i += 3) {
                var [x, y, id] = [args[i], args[i + 1], args[i + 2]]
                points[id] = table(
                    [1, "x", x],
                    [1, "y", y],
                    [1, "id", id]
                )
            }
            event.points = points
        } else {
            let eventCode = cc.EventTouch.EventCode
            switch (event.getEventCode()) {
                case eventCode.BEGAN: event.name = 'began'; break
                case eventCode.MOVED: event.name = 'moved'; break
                case eventCode.ENDED: event.name = 'ended'; break
                case eventCode.CANCELLED: event.name = 'cancelled'; break
            }
            event.x = selTouch.getLocationX()
            event.y = selTouch.getLocationY()
        }
        // WARN: maybe multi result
        return callback(event)
    }, isMultiTouches, 0, swallowTouches)
    self.setTouchEnabled(true)
    return self
}
Layer.prototype.removeTouch = function () {
    var self = this
    self.unregisterScriptTouchHandler()
    self.setTouchEnabled(false)
    return self
}
Layer.prototype.onKeypad = function (callback) {
    var self = this
    self.registerScriptKeypadHandler(callback)
    self.setKeyboardEnabled(true)
    return self
}
Layer.prototype.removeKeypad = function () {
    var self = this
    self.unregisterScriptKeypadHandler()
    self.setKeyboardEnabled(false)
    return self
}
Layer.prototype.onAccelerate = function (callback) {
    var self = this
    self.registerScriptAccelerateHandler(callback)
    // self.setAccelerometerEnabled(true)
    return self
}
Layer.prototype.removeAccelerate = function () {
    var self = this
    self.unregisterScriptAccelerateHandler()
    // self.setAccelerometerEnabled(false)
    return self
}
// Layer.prototype.onEnter = function () {
//     var self = this
//     cc.log("Layer:onEnter()")
// }
// Layer.prototype.onExit = function () {
//     var self = this
//     cc.log("Layer:onExit()")
// }
Layer.prototype.dispose = function () {
    var self = this
    cc.log("Layer:dispose()")
}
Layer.prototype.extendsEvent = function () {
    var self = this
    function sceneEventHandler(eventType) {
        if (eventType === "enter") {
            self.onEnter()
        } else if (eventType === "exit") {
            self.onExit()
        } else if (eventType === "cleanup") {
            self.dispose()
        }
    }
    self.registerScriptHandler(sceneEventHandler)
    return self
}
